var _radialGradient, _linearGradient, _clipPath, _clipPath2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMelCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(0 24 -24 0 24 24)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#e01a22"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 24,
    x2: 24,
    y1: 16.3125,
    y2: 48
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#feffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2cddb"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 48,
    rx: 8,
    width: 48
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#43b17e",
    height: 48,
    rx: 8,
    width: 48
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48 34.5518v13.4482h-48v-13.2477c1.04506-1.1522 2.38311-2.0339 3.89654-2.5273-.39916-1.2004-.61529-2.4843-.61529-3.8188 0-6.6791 5.41456-12.0937 12.09375-12.0937 5.1499 0 9.5479 3.2189 11.2919 7.7544 1.44-.8183 3.1054-1.2857 4.88-1.2857 5.1624 0 9.401 3.9551 9.8511 9.0005.0287-.0003.0575-.0005.0864-.0005 2.5591 0 4.87 1.0626 6.5156 2.7706z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m45.0938 20.5303c-.0625.0006-.125.0009-.1876.0009-9.5786 0-17.3437-7.765-17.3437-17.3437 0-.06258.0003-.12508.001-.1875h-3.0002c-.0005.06243-.0008.12493-.0008.1875 0 11.2355 9.1082 20.3437 20.3437 20.3437.0626 0 .1251-.0002.1876-.0008z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.4699 3c-.0008.06241-.0011.12491-.0011.1875 0 7.9736 6.4638 14.4375 14.4374 14.4375.0626 0 .1251-.0004.1876-.0012v-3.0003c-.0624.001-.1249.0015-.1876.0015-6.3167 0-11.4374-5.12074-11.4374-11.4375 0-.06262.0005-.12512.0015-.1875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.0938 11.8114c-.0468.0007-.0937.0011-.1407.0011-4.7375 0-8.5781-3.84056-8.5781-8.57812 0-.07838.0011-.15651.0031-.23438h3.0017c-.0032.07773-.0048.15586-.0048.23438 0 3.08071 2.4974 5.57812 5.5781 5.57812.047 0 .0939-.00058.1407-.00174z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m7.59375 35.7656 2.39063 3.9844h-4.73438l-2.34375 4.125h4.78125l2.29688-4.0425 2.29682 4.0425h4.7813l-2.3437-4.125h-4.73442l2.39062-3.9844-2.39062-4.0781z",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#231f20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.0131 42.0934h-1.8867v1.0397h2.1562v.693h-2.9263v-3.9274h2.8878v.6931h-2.1177v.8471h1.8867z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.8964 39.2826-.8085-2.9263v2.9263h-.7316v-3.9275h1.1166l.8086 2.7339.8471-2.7339h1.1166v3.9275h-.7316v-2.9263l-.8471 2.9263z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.1633 35.3551h-.7701v3.9275h.7701z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.9881 35.3551h-.7701v3.9275h.7701z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.3702 35.3551h-.77v3.9275h.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.771 39.8987h-.7701v3.9274h.7701z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.5143 36.8953h1.5787v-1.5402h.7701v3.9275h-.7701v-1.7327h-1.5787v1.7327h-.7701v-3.9275h.7701z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.3256 39.2826h-.8086v-3.2344h-.9154v-.6931h2.625v.6931h-.901z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.5343 43.8261h-.8086v-3.2343h-.9241v-.6931h2.6954v.6931h-.9627z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.7654 38.012c0 .8856-.5776 1.3476-1.5787 1.3476-.9241 0-1.5402-.385-1.5017-1.3091v-2.6954h.7701v2.7339c0 .2695.1925.6161.7701.6161.5005 0 .7701-.2696.7701-.6161v-2.7724h.7701z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.0583 42.0934h-1.8482v1.0397h2.1563v.693h-2.9649v-3.9274h2.8878v.6931h-2.0792v.8471h1.8482z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m34.9836 39.2826h-1.9638v-3.9275h1.7712c.8086 0 1.2322.3851 1.2322.9626 0 .4621-.2695.8087-.6161.8857.4236.1155.7701.539.7701 1.0396 0 .6161-.462 1.0396-1.1936 1.0396zm-1.1167-.616h.9241c.3081 0 .5776-.2311.6161-.5391 0-.3851-.2695-.5776-.6161-.5776h-.9241zm1.4247-2.2333c0-.2695-.231-.4621-.4621-.4621h-.9626v.9627h.9241c.3466 0 .5006-.2696.5006-.5006z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m36.7313 40.9768c0 .5776-.3465.8471-.693.9627.308.1154.5775.308.5775.847l.0096.0872c.0356.3229.0738.6701.1445.9524h-.8087c-.0388-.1358-.0482-.3205-.0579-.5097-.0096-.1864-.0194-.3771-.0576-.5299-.077-.308-.2695-.5005-.693-.5005h-.6546v1.5401h-.8086v-3.9274h1.7712c.8086 0 1.2706.385 1.2706 1.0781zm-2.2332-.385v1.0781h.9626c.308 0 .5005-.308.5005-.5391 0-.308-.231-.539-.539-.539z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.5521 39.8987h.7701v3.2344h1.8483v.693h-2.6184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.6454 38.243c0-.3851-.3466-.5006-1.0012-.6161-.8085-.154-1.2706-.5391-1.2706-1.1551 0-.7701.7316-1.1937 1.4632-1.1937 1.0396 0 1.5017.6546 1.5017 1.2707h-.7701c0-.385-.2311-.6161-.6931-.6161-.4236 0-.6931.154-.6931.4621 0 .3862.3227.4496.8334.5499.1003.0197.2079.0409.3217.0661.7316.1541 1.1167.5391 1.1167 1.1552 0 .6545-.5475 1.2321-1.6256 1.2321-1.1551 0-1.5318-.6161-1.5318-1.3091h.7701c0 .3465.308.6546.8086.6546.5005 0 .7701-.2311.7701-.5006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.7046 38.243c0-.3851-.3851-.5006-1.0012-.6161-.7701-.154-1.2706-.5391-1.2706-1.1551 0-.7701.7316-1.1937 1.4632-1.1937 1.0396 0 1.5017.6546 1.5017 1.2707h-.7701c0-.385-.2311-.6161-.6931-.6161-.4236 0-.6931.154-.6931.4621 0 .3862.3227.4496.8334.5499.1003.0197.2079.0409.3217.0661.7316.1541 1.1167.5391 1.1167 1.1552 0 .6545-.5006 1.2321-1.5787 1.2321-1.1552 0-1.5787-.6161-1.5787-1.3091h.7701c0 .3465.2695.6546.8086.6546.5005 0 .7701-.2311.7701-.5006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.1833 41.9009c0 .7701.3466 1.3862 1.0011 1.3862.5006 0 .7316-.2695.8471-.7701h.8086c-.1155.8471-.7701 1.3861-1.6942 1.3861-1.1936 0-1.8097-.9241-1.8097-2.0407s.6161-2.0407 1.8097-2.0407c.9627 0 1.5787.5775 1.6942 1.3476h-.8086c-.1155-.3465-.3465-.6545-.8471-.6545-.6545 0-1.0011.6545-1.0011 1.3861z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.819 41.9009c.0468.7701.3934 1.3862 1.0011 1.3862.5474 0 .7785-.2695.8471-.7701h.8086c-.0687.8471-.7232 1.3861-1.6942 1.3861-1.1468 0-1.7629-.9241-1.8097-2.0407.0468-1.1166.6629-2.0407 1.8097-2.0407 1.0095 0 1.6255.5775 1.6942 1.3476h-.8086c-.0686-.3465-.2997-.6545-.8471-.6545-.6077 0-.9543.6545-1.0011 1.3861z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMelCloud);
export default __webpack_public_path__ + "static/media/MELCloud.ef96f7ee95bab533e521a8a57100bf70.svg";
export { ForwardRef as ReactComponent };